/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitInductor = createReactComponent("outline", "circuit-inductor", "IconCircuitInductor", [["path", { "d": "M2 14h3v-2a2 2 0 1 1 4 0v2v-1.5a2.5 2.5 0 1 1 5 0v1.5v-1.5a2.5 2.5 0 1 1 5 0v1.5h3", "key": "svg-0" }]]);

export { IconCircuitInductor as default };
//# sourceMappingURL=IconCircuitInductor.mjs.map
